import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import {
  TIRE_SET_RELOCATE_INTRO_TEXTS,
  TIRE_SET_RELOCATE_SUMMARY_STEP,
  TIRE_SET_RELOCATE_WAREHOUSE_STEP,
} from "./consts";
import RelocateSummaryScene from "./scenes/RelocateSummaryScene";
import RelocateWarehouseScene from "./scenes/RelocateWarehouseScene";
import { TireSetRelocateIntroProps, TireSetRelocateSceneProps } from "./types";

/** Scena za korak premještaja seta guma. */
const STEP_SCENES: Record<number, React.FC<TireSetRelocateSceneProps>> = {
  [TIRE_SET_RELOCATE_WAREHOUSE_STEP]: RelocateWarehouseScene,
  [TIRE_SET_RELOCATE_SUMMARY_STEP]: RelocateSummaryScene,
};

/** Lijevi panel premještaja: set guma seli s jednog skladišta na drugo. */
const TireSetRelocateIntro: React.FC<TireSetRelocateIntroProps> = ({ stepCurrent, stepCount, ...sceneProps }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : TIRE_SET_RELOCATE_WAREHOUSE_STEP;
  const Scene = STEP_SCENES[stepKey];
  const text = TIRE_SET_RELOCATE_INTRO_TEXTS[stepKey];
  // Naziv skladišta se razrješava tek pri ulasku u potvrdu; nakon povratka i promjene odabira bio bi zastario.
  const props: TireSetRelocateSceneProps =
    stepKey === TIRE_SET_RELOCATE_SUMMARY_STEP
      ? sceneProps
      : { currentSet: sceneProps.currentSet, formValues: sceneProps.formValues };

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepKey}
      stepCount={stepCount}
    >
      <Scene {...props} />
    </ShowcaseIntro>
  );
};

export default memo(TireSetRelocateIntro);
